import React from "react";
import styles from "./Pricing.module.css";
import Button from 'react-bootstrap/Button';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FooterNav from "../../../components/footer/FooterNav";
import { useNavigate } from "react-router-dom";

function Pricing() {
    const navigate = useNavigate();

    return (
        <div className={styles["pricing-container"]} id="pricing">
            <div className={styles["pricing-content"]}>
                <div className={styles["pricing-heading"]}>
                    <div className={styles["pricing-emblem"]}>
                        <ShoppingCartIcon className={styles["cart-icon"]} />
                    </div>

                    <h2>Explore Our Current Plan</h2>

                    <p className={styles["pricing-desc"]}>
                        Select a plan suitable for your needs. Need more credits? <a href="https://presagetechnologies.com/contact-us" target="__blank" rel="noopener noreferrer" className={styles["txt-link"]}>Contact us</a>, we’d be happy to help! 
                    </p>
                </div>

                <div className={styles["price-card"]}>
                    <h3>FREE TIER</h3>
                    
                    <h4 className={styles["price-tag"]}>
                        <span>$</span>
                        0.00
                        <span>/mo</span>
                    </h4>

                    <p className={styles["price-desc"]}>
                        <span>100 processing credits per month</span> & all we have to offer, 
                        for the convenient price of free ninety-nine! 
                    </p>

                    <Button 
                        className={`${styles["btn-primary"]} 
                        ${styles["btn-width-full"]}`} 
                        variant="primary" 
                        // onClick={() => navigate("/auth/register")}
                        href="/auth/register"
                    >
                        Register Now
                        <NorthEastIcon className={styles["btn-arrow"]}/>
                    </Button>
                </div>
            </div>


            <FooterNav />
        </div>
    )
}

export default Pricing;